import styled, { css } from "styled-components";

import { Tabs } from "@ui/Molecules";
import { text } from "@ui/helpers";

export const Root = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.palette.white};
  min-height: inherit;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabsUnderline = styled.div`
  display: none;
  border-bottom: 1px solid ${props => props.theme.palette.grey100};

  ${props => props.theme.breakpoints.desktop} {
    display: block;
  }
`;

export const ProfileNavigationTabs = styled(Tabs).attrs({
  variant: "links",
})`
  gap: ${props => props.theme.spacing.spacing_64};
`;

export const ProfileNavigationTab = styled(ProfileNavigationTabs.Tab)`
  ${text("semibold_16")}
  padding: ${props => props.theme.spacing.spacing_24} 0;
  margin: 0;
  display: flex;
  gap: ${props => props.theme.spacing.spacing_12};

  &::after {
    bottom: 0;
  }
`;
